module.exports = __webpack_public_path__ + "static/bali-with-love-78092c88a80a3e4e34cff633e97819c7.png";